/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_Headline_AfterInputs */

const en_guestlist_headline_after = /** @type {(inputs: Guestlist_Headline_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guestlist. The relationship, one list away.`)
};

/**
* | output |
* | --- |
* | "Guestlist. The relationship, one list away." |
*
* @param {Guestlist_Headline_AfterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_headline_after = /** @type {((inputs?: Guestlist_Headline_AfterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_Headline_AfterInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_headline_after(inputs)
});